export default __webpack_public_path__ + "static/media/powered.f6ca1170.png";